var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Edit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99222 1.03809C9.77477 0.820637 9.42221 0.820637 9.20476 1.03809L7.34871 2.89415L1.78052 8.46232C1.70279 8.54005 1.6498 8.63905 1.62825 8.74685L0.885822 12.459C0.84931 12.6415 0.906452 12.8302 1.0381 12.9619C1.16974 13.0935 1.35847 13.1507 1.54103 13.1142L5.25315 12.3717C5.36094 12.3502 5.45994 12.2972 5.53767 12.2195L11.1034 6.65379C11.1042 6.65296 11.105 6.65213 11.1059 6.6513C11.1067 6.65046 11.1075 6.64963 11.1084 6.64879L12.9619 4.79524C13.1794 4.57779 13.1794 4.22523 12.9619 4.00778L9.99222 1.03809ZM10.7121 5.4701L11.7807 4.40151L9.59849 2.21928L8.52989 3.28787L10.7121 5.4701ZM7.74243 4.07533L2.68719 9.13056L2.14163 11.8584L4.86943 11.3128L9.92467 6.25756L7.74243 4.07533Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Edit);
export default __webpack_public_path__ + "static/media/100-edit.1381ebec79662629f2aec6fae51e2804.svg";
export { ForwardRef as ReactComponent };